import React, { useCallback } from 'react'

import { renderers } from '@markdoc/markdoc'

import { Layout } from './components/Layout'
import { collectHeadings, parseHtml } from './utils'
import { Fence } from '~/components/SyntaxRenderer/components/Fence'
import { Heading } from '~/components/SyntaxRenderer/components/Heading'
import { MarkdownLink as Link } from '~/components/SyntaxRenderer/components/Link'
import { Table } from '~/components/SyntaxRenderer/components/Table'
import { CONTENT_TYPE } from '~/types/content'

interface SyntaxRendererProps {
  content: any,
  title?: string,
  lastModifiedDate?: string,
  providerContentSlug?: string,
  showEditButtons?: boolean,
  type?: CONTENT_TYPE,
  props?: any,
  isConsumerSide?: boolean,
  url?: string,
}

export const SyntaxRenderer = ({
  content,
  title,
  lastModifiedDate,
  providerContentSlug,
  showEditButtons = false,
  type = CONTENT_TYPE.HTML,
  isConsumerSide = false,
  url,
  ...props
}: SyntaxRendererProps) => {

  const htmlNodes = useCallback(() => parseHtml(content), [content])

  const nodes = type === CONTENT_TYPE.HTML ? htmlNodes() : content

  return (
    <Layout 
      title={title} 
      tableOfContents={content ? collectHeadings({ nodes, type }) : []}
      lastModifiedDate={lastModifiedDate}
      providerContentSlug={providerContentSlug}
      showEditButtons={showEditButtons}
      isGraphQl={type === CONTENT_TYPE.GRAPHQL}
      isConsumerSide={isConsumerSide}
      url={url}
      {...props}>
      {(type === CONTENT_TYPE.MARKDOWN || type === CONTENT_TYPE.GRAPHQL) && renderers.react(
        content,
        React,
        {
          components: {
            Fence,
            Table,
            Link,
            Heading,
          }
        }
      )}
      {type === CONTENT_TYPE.HTML && htmlNodes()}
    </Layout>
  ) 
}